exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-toolbar .fc-center h2{font-size:1.4rem;margin-bottom:0}", ""]);

// exports
